module.exports = __webpack_public_path__ + "media/images/icons/media-skip-backward-f167ace0b63fe41aae0800c8b0e08a61.svg";